<template>
  <span>
    <b-table
      :fields="[
        {
          key: 'numero',
          label: $t('Detalhes'),
        },
        {
          key: 'cadastrado',
          label: $t('Data'),
        },
        {
          key: 'status_nome',
          label: $t('Status'),
        },
        {
          key: 'actions',
          label: '',
          class: 'text-right',
          thStyle: { width: '120px', minWidth: '120px' },
        },
      ]"
      :items="itens"
      :responsive="true"
      striped
      hover
      show-empty
      small
      outlined
      stacked="md"
      table-class="mb-3"
    >
      <template v-slot:cell(numero)="data">
        Número:
        <strong>
          {{ data.item.numero }}
        </strong>
        <br />
        Destinatário:
        <strong>
          {{ data.item.nome_completo_detinatario }}
        </strong>
        <br />
        Assunto:
        <strong>
          {{ data.item.assunto }}
        </strong>
        <br />
        Técnico:
        <strong>
          {{ data.item.tecnico }}
        </strong>
        <br />
        Unidade:
        <strong>
          {{ data.item.unidade.nome }}
        </strong>
        <br />
        <i
          class="mdi mdi-lock mdi-18px text-danger"
          v-if="data.item.privado == 1"
          v-b-popover.hover.top="'Oficio com Sigilo'"
        ></i>

        <b-popover :target="'popover-' + data.item.id" triggers="hover focus">
          <template #title>{{ data.item.assunto }}</template>
          <p
            class="my-4"
            v-html="$options.filters.limit(data.item.conteudo, 300)"
          ></p>
        </b-popover>

        <b-link href="#" role="button" :id="'popover-' + data.item.id">
          <br />
          {{ $t("Resumo do ofício") }}
        </b-link>

      </template>

      <template v-slot:cell(cadastrado)="data">
        {{ data.item.cadastrado }}
      </template>

      <template v-slot:cell(status_nome)="data">
        <span class="small" v-html="data.item.status_nome"></span>
      </template>

      <template v-slot:cell()="data">
        <button
          @click.prevent="$emit('relacionar', data.item.id)"
          :class="
            'px-2 mb-0 btn btn-sm btn-success btn-relacionar-' + data.item.id
          "
          v-if="relacionar"
        >
          <i class="mdi mdi-connection" /> Relacionar
        </button>
        <button
          @click="$emit('editar', data.item.id)"
          v-else-if="$store.state.user.id == data.item.user_id"
          class="px-2 mb-0 btn btn-sm btn-success"
        >
          <i class="mdi mdi-square-edit-outline" />
        </button>
      </template>
      <template v-slot:empty="scope">
        <div class="text-center my-5">
          <img
            :alt="$t('No results')"
            class="mb-5"
            src="/img/icons/robot.svg"
            style="max-height: 165px"
          />
          <h3 class="bold">{{ $t("No records found") }}</h3>
        </div>
      </template>
    </b-table>

    <div class="row align-items-center" v-if="pagination">
      <div class="col-lg-6 col-md-12">
        <div class="form-group d-inline-flex mb-0">
          <select
            class="form-control"
            style="width: 70px"
            v-model="qtdPorPagina"
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
          </select>
        </div>
        <div class="d-inline-flex ml-2">
          <b-pagination
            :per-page="porpagina"
            :total-rows="pagination.total"
            v-model="paginaAtual"
          />
        </div>
      </div>
      <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
        <div class="float-lg-right">
          {{ $t("Showing page") }}
          {{ pagination.currentPage }} {{ $t("of") }}
          {{ pagination.totalPages }}
          {{ $t("pages in") }}
          {{ pagination.total }}
          {{ $t("records") }}
        </div>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: ["itens", "pagination", "page", "porpagina", "relacionar"],
  data() {
    return {
      qtdPorPagina: 5,
      paginaAtual: 1,
    };
  },
  created() {
    this.qtdPorPagina = this.porpagina;
    this.paginaAtual = this.page;
  },
  watch: {
    qtdPorPagina(newValue) {
      this.$emit("update:porpagina", parseInt(newValue));
      if (this.qtdPorPagina != this.porpagina) {
        this.$emit("reload");
      }
    },
    paginaAtual(newValue) {
      this.$emit("update:page", parseInt(newValue));

      if (this.paginaAtual != this.page) {
        this.$emit("paginar", parseInt(newValue));
      }
    },
  },
};
</script>

<style>
</style>
